import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'IconTier',
  props: {
    color: { default: '#333' },
    size: { default: 24 }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})